<template>
  <div id="reset-regist">
    <dd-header
      :headerType=1
    />
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>新しいパスワードを設定</h2>
        </div>
        <div class="input_list">
          <div class="manual">
            <label class="bold">半角英小文字、数字を含む8文字以上の20字以下のパスワードを設定してください。</label>
          </div>
          <ul>
            <li class="list_key">
              <label>{{label.password}}</label>
            </li>
            <li class="list_box">
              <input type="password" v-model="userForm.password" placeholder="********" maxlength="20"/>
            </li>
            <li class="list_key">
              <label>{{label.confirmPassword}}</label>
            </li>
            <li class="list_box">
              <input type="password" v-model="userForm.confirmPassword" placeholder="********" maxlength="20"/>
            </li>
            <li class="center_button">
              <button class="main_btn send_btn" @click="confirm()">設定</button>
            </li>
          </ul>
          <div v-if="errors.password"><label class="error_text">{{errors.password}}</label></div>
          <div v-if="errors.confirmPassword"><label class="error_text">{{errors.confirmPassword}}</label></div>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import * as Check from '../../utils/Check'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'

// Module
import Header from '../components/common/DcHeader'

export default {
  components: {
    'dd-header': Header,
    'dd-loading-modal': LoadingModal
  },
  props: {
  },
  data () {
    return {
      userForm: {
        password: '',
        confirmPassword: '',
        userEmail: '',
        token: ''
      },
      errors: {},
      submitDisable: false,
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      label: {
        password: '新しいパスワード',
        confirmPassword: '新しいパスワード（確認用）'
      }
    }
  },
  methods: {
    toLogin: function () {
      this.$router.push('/mmstyle/login')
    },
    confirm: function () {
      if (this.submitDisable) return
      this.submitDisable = true
      this.$refs.loadingModalRef.showModal(true)

      this.errors = {}
      this.validatedReqire()
      if (Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        this.submitDisable = false
        return
      }

      let payload = {
        userEmail: this.userForm.userEmail,
        token: this.userForm.token,
        password: this.userForm.password,
        confirmPassword: this.userForm.confirmPassword
      }
      axios.post(DC_URL.USER + '/reset/password', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.$router.push('/mmstyle/user/reset/complete')
            this.$refs.loadingModalRef.showModal(false)
          }
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.$refs.loadingModalRef.showModal(false)
        })
        .finally(() => {
          this.submitDisable = false
        })
    },
    fetchData: function () {
      App.setLocalStorage(DC_STORAGE_KEY.PASSWORD_DATA, this.userForm)
    },
    validatedReqire: function () {
      if (!Check.isPassword(this.userForm.password)) {
        this.errors['password'] = this.label.password + 'は半角英小文字、数字を含む8文字以上の20字以下のパスワードを設定してください。'
      }
      if (this.userForm.password !== this.userForm.confirmPassword) {
        this.errors['confirmPassword'] = this.label.confirmPassword + 'が一致しません。'
      }
    },
    // パスワードリセット時に送られるURLを、踏んで来る際にトークンチェック
    tokenCheck: function () {
      let payload = {
        userEmail: this.$route.query.email,
        token: this.$route.query.token
      }
      axios.post(DC_URL.USER + '/reset/check-reset-password-token', payload
      ).then(response => {
      }).catch(error => {
        this.isRegistrable = false
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    }
  },
  created () {
    let lForm = App.getLocalStorage(DC_STORAGE_KEY.PASSWORD_DATA)
    this.tokenCheck()
    if (Object.keys(lForm).length <= 0) {
      // GET 初回遷移
      this.userForm.userEmail = this.$route.query.email
      this.userForm.token = this.$route.query.token
      this.fetchData()
    } else {
      this.userForm = lForm
    }
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/PasswordResetUpdate.vue